// src/app/services/plaid.service.ts

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

// Interface for /api/create_link_token response
interface CreateLinkTokenResponse {
  link_token: string;
}

@Injectable({
  providedIn: 'root'
})
export class PlaidService {
  // Base API URL

  private baseApiUrl = environment.apiUrl.replace('/api', ''); // or directly use environment.apiUrl as needed


  constructor(private http: HttpClient) {}

  createLinkToken(): Observable<CreateLinkTokenResponse> {
    // Calls the server’s /api/create_link_token
    const url = `${this.baseApiUrl}/api/create_link_token`;
    return this.http.post<CreateLinkTokenResponse>(url, {});
  }

  exchangePublicToken(public_token: string, applicationGuid: string | null): Observable<any> {
    if (applicationGuid === null) {
      throw new Error('applicationGuid must not be null');
    }

    // Encode the data as application/x-www-form-urlencoded
    const body = new HttpParams()
      .set('public_token', public_token)
      .set('applicationGuid', applicationGuid);

    // Set the Content-Type header
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const url = `${this.baseApiUrl}/api/exchange_public_token`;
    return this.http.post(url, body.toString(), { headers });
  }
}
